import { useEffect } from 'react'

import { useDataBoxSelector } from 'app/common/data-box-store'
import { detailsFilter } from 'app/common/ui-next/_filter-compilations/details'
import { PlainRadioGroupBox } from 'app/common/ui-next/_filter-compilations/plain-radio-group-box'
import {
  detailsGroupFilter,
  detailsGroupFilterSelection,
  defaultDetailsGroupSelection,
  getDetailsGroupData,
  orgsFilterSelection,
  orgTypesFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = { id: string; pending: boolean }

export const GroupFilter = ({ id, pending }: Props) => {
  const details = useDataBoxSelector(detailsFilter, () => detailsFilter.data)
  const orgTypes = useDataBoxSelector(
    orgTypesFilterSelection,
    () => orgTypesFilterSelection.data,
  )
  const selectedOrgs = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)
  const singleOrg = selectedOrgs.length === 1
  const visible = details && orgTypes.length > 0

  useEffect(() => {
    if (!visible) {
      detailsGroupFilter.resetToDefault()
      detailsGroupFilterSelection.resetToDefault()
      return
    }

    detailsGroupFilter.updateData(() => getDetailsGroupData(singleOrg))
    detailsGroupFilter.setStatusReady()
    detailsGroupFilterSelection.updateData(() => defaultDetailsGroupSelection)
  }, [visible, singleOrg])

  if (!visible) return null
  return (
    <PlainRadioGroupBox
      id={id}
      label="Группировать по"
      dataBoxData={detailsGroupFilter}
      dataBoxSelection={detailsGroupFilterSelection}
      disabled={pending}
    />
  )
}
